;(function ($) {
  "use strict";
  $(document).ready(function () {
    responsiveTables();
  });
})(jQuery);

function responsiveTables() {
  var tableWrapper;

  $('#main-page-content table').each(function (i) {
    tableWrapper = $(this).parent();

    if (!tableWrapper.hasClass('table-wrapper')) {
      $(this).wrap('<div class="table-wrapper"></div>');
    }
  });
}
